export default __webpack_public_path__ + "static/media/1997.2c323ba1.png";